import PropTypes from 'prop-types'
import React from 'react'

import IconSecurityLocker from 'components/_special/IconSecurityLocker'
import List, { ListItem } from 'components/List'
import { H2 } from 'styles/components/typography'

import { SectionWrapperStyled, TextStyled } from './styles'

const DHowProtection = ({ data }) => {
  return (
    <SectionWrapperStyled className="bg--gray--op-06 d-md-flex align-items-md-center">
      <div className="row py-4 py-md-0">
        <div className="col-12 col-md-6">
          <IconSecurityLocker />
        </div>
        <div className="col-12 col-md-6 mt-4 mt-md-0">
          <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
          <TextStyled dangerouslySetInnerHTML={{ __html: data.content }} />
          <List leftAlignment="text">
            {data.list.map((item, id) =>
              item ? (
                <ListItem
                  className="with-inverted-links"
                  key={`protection.${id}`}
                  bulletColor="dark-blue"
                >
                  {item}
                </ListItem>
              ) : null,
            )}
          </List>
        </div>
      </div>
    </SectionWrapperStyled>
  )
}

DHowProtection.propTypes = {
  data: PropTypes.object.isRequired,
}

DHowProtection.defaultProps = {}

export default DHowProtection
